export default __webpack_public_path__ + "static/62906-3a5f34f1211944f823556571157448c4.jpg";